/**
 * Calcula os dias restantes até a expiração
 * @param {Date} expirationDate 
 * @returns {number}
 */
export const getDaysUntilExpiry = (expirationDate) => {
  const now = new Date();
  const diffTime = expirationDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(0, diffDays);
};

/**
 * Revive dates in an object from JSON
 * @param {Object} obj 
 * @param {string[]} dateFields 
 * @returns {Object}
 */
export const reviveDatesInObject = (obj, dateFields) => {
  const result = { ...obj };
  dateFields.forEach(field => {
    if (result[field]) {
      result[field] = new Date(result[field]);
    }
  });
  return result;
};

/**
 * Calculate subscription revenue based on active keys
 * @param {AccessKey[]} accessKeys 
 * @returns {number}
 */
export const calculateSubscriptionRevenue = (accessKeys) => {
  const now = new Date();
  const activeKeys = accessKeys.filter(key => 
    key.isActive && new Date(key.expiresAt) > now
  );
  return activeKeys.length * 30; // R$ 30,00 por chave ativa
};

/**
 * Format currency to Brazilian Real
 * @param {number} amount 
 * @returns {string}
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
};